let VaccineService = function (Restangular) {
  const Service = Restangular.all('admin/vaccine');

  let count = (query) => {
    return Service.customGET('count', query);
  }

  let save = (resource) => {
    if (resource.save) {
        return resource.save();
    } else {
        return Service.post(resource);
    }
  }

  let index = (query) => {
    query = query || {};
    query.deleted_at = 'null';
    return Service.getList(query);
  }

  let load = (query) => {
    query.deleted_at = 'null';
    return new Promise((resolve, reject) => {
        count(query)
        .then(response => {
            let count = response[0];
            index(query)
            .then(data => {
                resolve({count, data});
            })
            .catch(err => {
                reject(err);
            });
        })
        .catch(err => {
            reject(err);
        });
    });
  }

  let show = (id) => {
    return Service.get(id);
  }

  let destroy = (resource) => {
    resource.deleted_at = moment();
    return resource.save();
  }

  let downloadReport = () => {
    return Restangular.one('vaccine/report').get()
  }

  let updatePosition = (id, data) => {
    return Service.customPATCH(data, `position/${id}`);
  };

  return { index, load, save, show, destroy, downloadReport, updatePosition} ;
};

VaccineService.$inject = ['Restangular'];

export default VaccineService;



// WEBPACK FOOTER //
// ./client/app/components/vaccine/vaccine.service.js